module.exports = __webpack_public_path__ + "media/images/countrysquared/gt-126bc41f04d2684edc1f0c5bb7776205.svg";